<template>
  <div class="page-footer">
    <div class="first-content">
      <div class="page-footer-content">
        <div>
          <ul class="logo-content">
            <li>
              <a href="/">
                <img :src="logImg" alt="" />
              </a>
            </li>
            <li class="sub-title slogan">
              <!-- {{ translateTitle("让金融更高效，让财富更自由") }}
             -->
              <span class="web-slogan">
                {{ slogan["web_slogan_" + language] }}
              </span>
              <a :href="tgUrl" target="_blank" v-if="isbitda">
                <img
                  class="bitda-tg"
                  src="../../assets/img/home/bitda/bitda-tg-icon.png"
                  alt=""
                />
              </a>
            </li>
            <li class="footer-icons" v-if="!is8V && !isbitda">
              <a :href="tgUrl" target="_blank">
                <i class="iconfont iconf-4"> </i>
              </a>
              <a
                href="https://twitter.com/5aCrypto"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-"> </i>
              </a>
              <a
                href="https://www.instagram.com/5a_cryptoexchange/"
                target="_blank"
                v-if="is5A"
              >
                <i
                  class="iconfont iconinstagram-fill"
                  style="font-size:18px"
                ></i>
              </a>
              <a
                href="https://www.facebook.com/5AExchange-108301618427813"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-1"></i>
              </a>
              <a
                href="https://discord.com/channels/935463001014804501"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-13-discord"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCF4YAHj_FRz77Ik0LnhxnxQ"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-11-YouTube"></i>
              </a>
              <a
                href="https://www.tiktok.com/@5aexchangeglobal"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-12-TikToke"></i>
              </a>
              <a
                href="https://medium.com/@5AExchange"
                target="_blank"
                v-if="is5A"
              >
                <i class="iconfont iconf-10-Medium"></i>
              </a>
            </li>
          </ul>
        </div>
        <div>
          <ul class="tg-content">
            <!-- <li>
            <img src="../../assets/img/huixintg.png" alt="" />
          </li> -->
            <qrcode-vue
              class="qr_code_canvas"
              v-show="tgUrl"
              :value="tgUrl"
              :size="78"
              level="H"
            ></qrcode-vue>
            <li>{{ translateTitle(qrcodeTitle) }}</li>
          </ul>
        </div>
        <div>
          <ul class="text-content">
            <li class="sub-title">{{ translateTitle("关于") }}</li>
            <a :href="tipUrl" target="_blank">
              <li>{{ translateTitle("公告中心") }}</li>
            </a>
            <a :href="helpUrl" target="_blank">
              <li>{{ translateTitle("帮助中心") }}</li>
            </a>
            <a href="/aboutus" target="_blank" v-if="is8V">
              <li>{{ translateTitle("关于我们") }}</li>
            </a>
            <a href="https://about.tope.com/" target="_blank" v-if="isHX">
              <li>{{ translateTitle("关于我们") }}</li>
            </a>
            <a
              href="https://support.5a.com/hc/zh-cn/articles/4846701545369"
              target="_blank"
              v-if="is5A && (language == 'zh_CN' || language == 'zh_HK')"
            >
              <li>{{ translateTitle("关于我们") }}</li>
            </a>
            <a
              href="https://support.5a.com/hc/en-001/articles/4846701545369"
              target="_blank"
              v-else-if="is5A"
            >
              <li>{{ translateTitle("关于我们") }}</li>
            </a>
          </ul>
        </div>
        <!-- <div>
        <ul class="text-content">
          <li class="sub-title">商务</li>
          <li>API接入</li>
          <li>上币申请</li>
        </ul>
      </div> -->
        <div>
          <ul class="text-content">
            <li class="sub-title">{{ translateTitle("条款") }}</li>
            <a :href="serviceUrl" target="_blank">
              <li>{{ translateTitle("服务协议") }}</li>
            </a>
            <a :href="privacyUrl" target="_blank">
              <li>{{ translateTitle("隐私协议") }}</li>
            </a>
            <a :href="statementUrl" target="_blank">
              <li>{{ translateTitle("免责声明") }}</li>
            </a>
            <span target="_blank" @click="onKycClick" v-if="isbitda">
              <li>{{ translateTitle("KYC政策") }}</li>
            </span>
          </ul>
        </div>
        <div>
          <ul class="text-content">
            <li class="sub-title">{{ translateTitle("其他") }}</li>
            <a :href="rateUrl" target="_blank">
              <li>{{ translateTitle("费率标准") }}</li>
            </a>
            <span
              :href="rateUrl"
              target="_blank"
              v-if="userInfo && is5A"
              @click="onAPIClick"
            >
              <li>{{ translateTitle("API") }}</li>
            </span>
            <a :href="apiUrl" target="_blank" v-if="hasAPI">
              <li>{{ translateTitle("API") }}</li>
            </a>
          </ul>
        </div>
      </div>
    </div>
    <div class="second-content V2 V3" v-if="isbitda">
      <div>
        <p>
          BITDA LIMITED CANADA MSB number：M22902291
        </p>
        <p>
          ADDRESS：1530 ALBION ROAD TORONTO ON M9V 5H4
        </p>
      </div>
      <div>
        <p>
          BITDA LIMITED U.S MSB number：31000205754185
        </p>
        <p>ADDRESS：4255 South Buckley Road #1296 Aurora COLORADO 80013</p>
      </div>
    </div>
    <div class="second-content V2" v-if="is5A">
      <p>
        {{ projectName }}
        {{
          translateTitle(
            "交易所注册成立于美国，受权威美国MSB监管（监管号：31000205987277）和加拿大MSB监管（监管号：M22871814）"
          )
        }}<br />
        {{ projectName }}
        {{
          translateTitle(
            "历来重视合规义务，始终严格遵守各地监管机构相关要求，并请您遵守所在国家或地区的相关法律法规。"
          )
        }}
      </p>
      <p>
        <img src="../../assets/img/home/warning-icon-white.png" alt="" />
        {{
          translateTitle(
            "风险提示：数字货币交易存在巨大风险，请您谨慎购买，并注意交易风险。"
          )
        }}
      </p>
    </div>
    <div class="second-content" v-if="isB9">
      <p>
        {{ projectName }}
        {{
          translateTitle(
            "交易所注册成立于美国，受权威美国MSB监管（监管号：31000195198839）和加拿大MSB监管（监管号：M21192152）"
          )
        }}
      </p>
      <p>
        {{ projectName }}
        {{
          translateTitle(
            "历来重视合规义务，始终严格遵守各地监管机构相关要求，并请您遵守所在国家或地区的相关法律法规。"
          )
        }}
      </p>
      <p>
        <img src="../../assets/img/home/warning-icon.png" alt="" />
        {{
          translateTitle(
            "风险提示：数字货币交易存在巨大风险，请您谨慎购买，并注意交易风险。"
          )
        }}
      </p>
    </div>
  </div>
</template>
<script>
import { translateTitle } from "@/assets/js/i18n";
import QrcodeVue from "qrcode.vue";
import { mapGetters } from "vuex";
import {
  VUE_UNION_STATION,
  VUE_APP_ID,
  getEnv,
} from "@/assets/js/stationSetting";
export default {
  components: {
    QrcodeVue,
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      language: "user/language",
    }),
  },
  data() {
    return {
      slogan: "让金融更高效 让财富更自由",
      tgUrl: "",
      tipUrl: "",
      qrcodeTitle: "",
      rateUrl: "",
      serviceUrl: "",
      privacyUrl: "",
      statementUrl: "",
      helpUrl: "",
      projectName: "",
      logImg: "",
      apiUrl: "",
      isHX: false,
      is5A: false,
      is8V: false,
      isB9: false,
      isbitda: false,
      hasAPI: false,
    };
  },
  created() {
    if (VUE_UNION_STATION == "B9") {
      this.isB9 = true;
      this.projectName = "B9";
      this.slogan = "最安全，最高效的数字理财平台";
      this.logImg = require("../../assets/img/bijiu-logo.png");
    } else if (VUE_UNION_STATION == "BullxCow") {
      this.slogan = "最安全，最高效的数字理财平台";
      this.logImg = require("../../assets/img/logo3.png");
    } else if (VUE_UNION_STATION == "MaskEx") {
      this.slogan = "最安全，最高效的数字理财平台";
      this.logImg = require("../../assets/img/mask-logo.png");
    } else if (VUE_UNION_STATION == "100Ex") {
      this.slogan = "最安全，最高效的数字理财平台";
      this.logImg = require("../../assets/img/logo_100.png");
    } else if (VUE_UNION_STATION == "TopCredit") {
      this.isHX = true;
      this.slogan = "让金融更高效 让财富更自由";
      this.logImg = require("../../assets/img/logo.png");
    } else if (VUE_UNION_STATION == "EverTrust") {
      this.slogan = "让金融更高效 让财富更自由";
      this.logImg = require("../../assets/img/everTrust-logo.png");
    } else if (VUE_UNION_STATION == "8V") {
      this.is8V = true;
      this.logImg = require("../../assets/img/logo_8V.png");
      this.slogan = "让金融更高效 让财富更自由";
    } else if (VUE_UNION_STATION == "UEEx") {
      this.logImg = require("../../assets/img/logo_UEEx.png");
      this.slogan = "让金融更高效 让财富更自由";
    } else if (VUE_UNION_STATION == "Ahex") {
      this.logImg = require("../../assets/img/logo_Ahex.png");
      this.slogan = "最安全，最高效的数字理财平台";
    } else if (VUE_UNION_STATION == "5A") {
      this.is5A = true;
      this.projectName = "5A";
      this.logImg = require("../../assets/img/logo_5A.png");
      this.slogan = "数字资产交易所";
    } else if (VUE_UNION_STATION == "bitda") {
      this.isbitda = true;
      this.logImg = require("../../assets/img/logo_bitda_footer.png");
      this.slogan = "財富交易，託付必達";
    } else if (VUE_UNION_STATION == "S6") {
      this.logImg = require("../../assets/img/logo_S6.png");
      this.slogan = "数字理财 赢得未来";
    } else if (VUE_UNION_STATION == "easy") {
      this.logImg = require("../../assets/img/logo_easy.png");
      this.slogan = "数字理财 赢得未来";
    } else if (VUE_UNION_STATION == "spex") {
      this.logImg = require("../../assets/img/logo_spex.png");
      this.slogan = "数字理财 赢得未来";
    } else {
      this.slogan = "最安全，最高效的数字理财平台";
      this.logImg = require("../../assets/img/logo3.png");
    }

    this.slogan = JSON.parse(sessionStorage.getItem("solgan"));

    if (!JSON.parse(sessionStorage.getItem("clause"))) {
      getEnv();
    }
    let clauseList = JSON.parse(sessionStorage.getItem("clause"));
    let othersList = JSON.parse(sessionStorage.getItem("others"));
    let noticeList = JSON.parse(sessionStorage.getItem("zendesk_notice"));
    let qrcode = JSON.parse(sessionStorage.getItem("qrcode"));
    let about = JSON.parse(sessionStorage.getItem("about"));
    // if (this.is8V) {
    //   this.rateUrl = othersList[0].language[`url_${this.language}`];
    //   this.serviceUrl = clauseList[0].language[`url_${this.language}`];
    //   this.tipUrl = about[0].language[`url_${this.language}`];
    //   this.privacyUrl = clauseList[1].language[`url_${this.language}`];
    //   this.statementUrl = clauseList[2].language[`url_${this.language}`];
    //   this.helpUrl = about[1].language[`url_${this.language}`];
    // } else {
    //   this.privacyUrl = clauseList[1].url;
    //   this.statementUrl = clauseList[2].url;
    //   this.serviceUrl = clauseList[0].url;
    //   this.rateUrl = othersList[0].url;
    //   this.tipUrl = about[0].url;
    //   this.helpUrl = about[1].url;
    // }

    if (othersList[0].language) {
      this.rateUrl = othersList[0].language[`url_${this.language}`];
    } else {
      this.rateUrl = othersList[0].url;
    }
    if (othersList[1]) {
      this.hasAPI = true;
      this.apiUrl = othersList[1].url;
    } else {
    }

    if (clauseList[0].language) {
      this.serviceUrl = clauseList[0].language[`url_${this.language}`];
    } else {
      this.serviceUrl = clauseList[0].url;
    }
    if (about[0].language) {
      this.tipUrl = about[0].language[`url_${this.language}`];
    } else {
      this.tipUrl = about[0].url;
    }

    if (clauseList[1].language) {
      this.privacyUrl = clauseList[1].language[`url_${this.language}`];
    } else {
      this.privacyUrl = clauseList[1].url;
    }

    if (clauseList[2].language) {
      this.statementUrl = clauseList[2].language[`url_${this.language}`];
    } else {
      this.statementUrl = clauseList[2].url;
    }
    if (about[1].language) {
      this.helpUrl = about[1].language[`url_${this.language}`];
    } else {
      this.helpUrl = about[1].url;
    }

    this.tgUrl = qrcode.ori_url;
    this.qrcodeTitle = qrcode.title;
  },
  methods: {
    translateTitle,
    onKycClick() {
      this.$router.push({
        path: "/kyc-notice",
      });
    },
    onAPIClick() {
      this.$emit("onApiClick");
    },
    onClickMore() {
      window.open(this.tipUrl);
    },
  },
};
</script>
<style lang="scss">
.page-footer {
  padding: 50px 0 20px;
  // position: fixed;
  // bottom: 0px;
  // left: 0px;
  .first-content {
    display: flex;
    justify-content: center;
  }
  .second-content {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 90px;
    border-top: 1px solid #fdac35;
    color: #fdac35;
    &.V2 {
      border-top: 1px solid #7e8392;
      color: #7e8392;
    }
    &.V3 {
      border-top: none;
      margin-top: 20px;
      width: 1200px;
      display: flex;
      justify-content: space-between;
      p {
        margin-bottom: 0;
        color: #786b8e;
      }
    }
    p {
      font-size: 14px;
      line-height: 2;
      margin-bottom: 10px;
      vertical-align: middle;
      img {
        width: 14px;
        height: 16px;
        vertical-align: middle;
      }
    }
  }
  background-color: #17232c;
  color: #fff;
  text-align: center;
  user-select: none;

  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
  .page-footer-content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    // padding: 0px 360px;
    width: 1000px;
    .logo-content img {
      height: 42px;
    }

    .footer-icons {
      margin-top: 30px;
      .iconfont {
        width: 16px;
        height: 12px;
        color: #7e8392;
        margin-right: 16px;
        cursor: pointer;
        &:hover {
          color: #357de1;
          // width: 20px;
          // height: 20px;
          // border-radius: 50%;
          // color: #ffffff;
        }
      }
    }
    .logo-content {
      text-align: left;
      img {
        width: 182px;
        height: 42px;
      }
      .sub-title {
        font-size: 14px;
        color: #7e8392;
        height: 20px;
        margin-top: 10px;
        vertical-align: middle;
        // &.slogan {
        //   width: 160px;
        // }
        .bitda-tg {
          width: 32px;
          height: 27px;
          margin-left: 13px;
          vertical-align: middle;
        }
      }
    }
    .tg-content {
      .qr_code_canvas {
        margin-bottom: 10px;
        canvas {
          border: 3px solid white;
        }
      }
      img {
        width: 80px;
        height: 80px;
      }
      li {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
    .text-content {
      vertical-align: top;
      li {
        color: #ffffff;
        font-size: 12px;
        margin: 0 0 17px;
        cursor: pointer;
        &:hover {
          color: rgba(255, 255, 255, 0.7);
        }
      }
      .sub-title {
        font-size: 16px;
        color: #7e8392;
        &:hover {
          color: #7e8392;
        }
      }
    }
  }
}
</style>
